module.exports = __webpack_public_path__ + "img/bahamas.1ed7c6c9.png";